import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_QUICKBOOKS_AUTH = `${ACCOUNT_SERVICE}/quickbooks-auth`;

export const quickBooksAuth = {
  getConfig: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_AUTH}/config`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  disconnect: async () => {
    const options = await apiOptions({
      url: `${API_QUICKBOOKS_AUTH}/disconnect`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
